// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"9ca1e25b","977":"c2b55491"}[chunkId] + ".chunk.js";
};